import { render, staticRenderFns } from "./NaturalPersonCustomers.html?vue&type=template&id=054999ca&external"
import script from "./NaturalPersonCustomers.vue?vue&type=script&lang=js"
export * from "./NaturalPersonCustomers.vue?vue&type=script&lang=js"
import style0 from "./NaturalPersonCustomers.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports